import React, { useRef } from 'react';
import { Form, Input, Select } from '../../ui/ot';
import { staffStatusOptions, staffStatusRequestId } from './staff_status';

export default function StaffStatusForm({ form, field, readonly = false }) {
    const path = name => [field.name, name].join('.');
    const original = useRef({
        code: form.getFieldValue(path('staff_status_code')) || 'unconfirmed',
        version: Number(form.getFieldValue(path('staff_status_version')) || 0),
    });
    const change = Form.useWatch(path('staff_status_edit'), form);
    const selectStatus = code => {
        if (code === original.current.code) {
            form.setFieldValue(path('staff_status_edit'), undefined);
            return;
        }
        form.setFieldValue(path('staff_status_edit'), {
            code,
            reason: change?.reason || '',
            effective_at: new Date().toISOString(),
            expected_version: original.current.version,
            request_id: staffStatusRequestId(),
        });
    };
    return <>
        <Form.Item label="人員狀態" name={path('staff_status_code')} disabled={readonly}>
            <Select aria-label="人員狀態" options={staffStatusOptions} onSelect={selectStatus} />
        </Form.Item>
        {change && <Form.Item label="異動原因" name={[path('staff_status_edit'), 'reason']} disabled={readonly}
            rules={change.code === 'withdrawn' ? [{ required: true, message: '請輸入退學原因' }] : []}>
            <Input.TextArea aria-label="異動原因" maxLength={1000} />
        </Form.Item>}
    </>;
}
